import { TriggerVariation } from "Redux/ProducerSlice";
import Document from "../ExternalLibraries/FlexSearch/document";
import { Link, Reference, Term } from "types/types";

export default class Searcher {
  currentTriggerIndex: number;
  currentLinkIndex: number;
  currentTermIndex: number;
  currentRefIndex: number;
  termsIndex?: Document;
  refsIndex?: Document;
  triggerIndex?: Document;
  linkIndex?: Document;

  constructor(content: any) {
    this.currentTriggerIndex = 0;
    this.currentLinkIndex = 0;
    this.currentTermIndex = 0;
    this.currentRefIndex = 0;
    this.addTrigger(content.triggers);
    this.addLink(content.links);
    this.addTerm(content.terms);
    this.addRef(content.refs);
  }

  generateTriggerIndex() {
    return new Document({
      tokenize: "strict",
      doc: {
        id: "id",
        index: ["label", "answer"],
        store: ["label", "trigger", "answer"],
      },
      preset: "performance",
    });
  }

  generateLinkIndex() {
    return new Document({
      tokenize: "forward",
      doc: {
        id: "id",
        index: ["name", "address", "description", "linkId"],
        store: ["name", "address", "description", "linkId"],
      },
      preset: "performance",
    });
  }
  generateTermsIndex() {
    return new Document({
      tokenize: "forward",
      doc: {
        id: "id",
        index: ["name", "description", "termId"],
        store: ["name", "description", "termId"],
      },
      preset: "performance",
    });
  }
  generateRefsIndex() {
    return new Document({
      tokenize: "forward",
      doc: {
        id: "id",
        index: ["code", "link", "description", "refId"],
        store: ["code", "link", "description", "refId"],
      },
      preset: "performance",
    });
  }

  addTerm(terms: any[]) {
    this.termsIndex = this.generateTermsIndex();

    terms.map((term) => {
      this.termsIndex?.add({
        id: this.currentTermIndex,
        name: term.name,
        description: term.description,
        termId: term.termId,
      });
      this.currentTermIndex++;
    });
  }

  addRef(refs: any[]) {
    this.refsIndex = this.generateRefsIndex();

    refs.map((ref) => {
      this.refsIndex?.add({
        id: this.currentRefIndex,
        code: ref.code,
        description: ref.description,
        link: ref.link,
        refId: ref.refId,
      });
      this.currentRefIndex++;
    });
  }

  addTrigger(triggers: TriggerVariation[]) {
    this.triggerIndex = this.generateTriggerIndex();

    triggers.map((trigger) => {
      this.triggerIndex?.add({
        id: this.currentTriggerIndex,
        label: trigger.label,
        trigger: trigger.trigger,
        answer: trigger.answer,
      });
      this.currentTriggerIndex++;
    });
  }

  addLink(links: any[]) {
    this.linkIndex = this.generateLinkIndex();

    links.map((link) => {
      this.linkIndex?.add({
        id: this.currentLinkIndex,
        name: link.name,
        address: link.address,
        description: link.description,
        linkId: link.linkId,
      });
      this.currentLinkIndex++;
    });
  }

  find(toSearch: string, filter: string) {
    console.log("find ", toSearch);
    if (filter === "links") {
      return this.linkIndex
        ?.search(toSearch, { enrich: true })
        .map((el: Link) => {
          return { type: "link", el: el };
        });
    }
    if (filter === "triggers") {
      return this.triggerIndex
        ?.search(toSearch, { enrich: true })
        .map((el: any) => {
          if (el.field === "label") {
            el.result = el.result.filter((t: any) => {
              return t.doc.label.toLowerCase().includes(toSearch.toLowerCase());
            });
          }

          return { type: "trigger", el: el };
        });
    }
    if (filter === "refs") {
      return this.refsIndex
        ?.search(toSearch, { enrich: true })
        .map((el: Reference) => {
          return { type: "ref", el: el };
        });
    }
    if (filter === "terms") {
      return this.termsIndex
        ?.search(toSearch, { enrich: true })
        .map((el: Term) => {
          return { type: "term", el: el };
        });
    }
    return [
      ...(this.triggerIndex
        ?.search(toSearch, { enrich: true })
        .map((el: any) => {
          return { type: "trigger", el: el };
        }) ?? []),
      ...(this.linkIndex?.search(toSearch, { enrich: true }).map((el: Link) => {
        return { type: "link", el: el };
      }) ?? []),
      ...(this.termsIndex
        ?.search(toSearch, { enrich: true })
        .map((el: Term) => {
          return { type: "term", el: el };
        }) ?? []),
      ...(this.refsIndex
        ?.search(toSearch, { enrich: true })
        .map((el: Reference) => {
          return { type: "ref", el: el };
        }) ?? []),
    ];
  }
}
